import React from 'react';
import { useState, useEffect } from 'react';
import { Button, Switch, Table, Typography, Space, Image, Flex, Form, Row, Col } from 'antd'
import { transactionData } from '../../../Data';
import { ActionButton, AlertModal, SearchInput } from '../../../components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';
let timer;
const { Text } = Typography;
const Transactiontable = () => {

    const navigate = useNavigate()
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const { transactionData, loadingtransaction, filters, pagination } = useSelector(state => state?.Transactiongetapi)

    useEffect(() => {
        dispatch(actionsApi?.getTransactionApi({ ...filters, ...pagination, pageNo: 1 }))
    }, [])

    const call = (pageNo = 1, pageSize = 10) => {
        dispatch(actionsApi?.getTransactionApi({ ...filters, pageNo, pageSize }))
    }

    function searchHandler(name, pageNo = 1, pageSize = 20) {
        dispatch(actionsApi?.getTransactionApi({ ...filters, name, pageNo, pageSize }))
    }

    function debounce(func, delay) {
        return function (...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)



    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Professioanl Name</Text>,
            dataIndex: 'professionalName',

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Email</Text>,
            dataIndex: 'email',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Phone Number</Text>,
            dataIndex: 'phoneNo'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'data'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 100,
            render: (_, row) => (
                <Space>
                    <ActionButton
                        title='View Transaction'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {navigate(`/transactions/detail/${row?.id}`)}}
                    />
                </Space>
            ),
        },
    ];
    return (
        <>
            <Flex vertical gap={20}>
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Row gutter={[16, 16]} align={'middle'}>
                        <Col lg={8} md={12} sm={24} xs={24}>
                            <SearchInput
                                name='name'
                                placeholder='Search Name'
                                value={form.getFieldValue('name') || ''}
                                prefix={<img src='/assets/icons/search.png' width={20} />}
                                className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                                onChange={(e) => debouncedSearchHandler(e.target.value, 1, 20)}
                            />
                        </Col>
                    </Row>
                </Form>
                <Table
                    size='large'
                    columns={columns}
                    dataSource={transactionData}
                    className='pagination'
                    showSorterTooltip={false}
                    scroll={{ x: 1300 }}
                    pagination={{
                        hideOnSinglePage: true,
                        total: pagination?.totalRecords,
                        pageSize: pagination?.pageSize,
                        defaultPageSize: pagination?.pageSize,
                        current: pagination?.pageNo,
                        size: "default",
                        pageSizeOptions: ['10', '20', '50', '100'],
                        onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                        showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                    }}
                    loading={
                        {
                            ...TableLoader,
                            spinning: loadingtransaction
                        }
                    }
                />
            </Flex>
        </>
    )
}

export { Transactiontable }